import {AppState} from '@app/context/context';
import {clientsColumnsStorage} from '@app/storage/clientsColumnsStorage';
import React from "react";

export interface UpdateClientsConfigEvent {
    config: Partial<AppState['clients']['config']>;
}

export function emitClientsConfigUpdate(
    setState: React.Dispatch<React.SetStateAction<AppState>>,
    event: UpdateClientsConfigEvent & {isSavedConfig?: boolean}
) {
    setState((prevState: AppState) => {
        const updatedConfig = {
            ...prevState.clients.config,
            ...event.config
        };

        if (event.isSavedConfig) {
            clientsColumnsStorage.set(updatedConfig);
        }

        return {
            ...prevState,
            clients: {
                ...prevState.clients,
                config: updatedConfig
            }
        };
    });
}
